import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import { DashboardImages, CommonImages } from "../reusableUI/images";

const BookingBySpecialist = ({
  values,
  nurseData,

  page,
  physioData,
}) => {
  const getOptions = () => {
    let nurseCounts = [];

    let physioCounts = [];
    let categories = [];
    const today = moment();

    switch (values) {
      case "Today": {
        nurseCounts = Array.from({ length: 24 }, (_, i) => {
          const hour = i;
          return nurseData.filter(
            (entry) => moment(entry.createdAt).hour() === hour,
          ).length;
        });

        physioCounts = Array.from({ length: 24 }, (_, i) => {
          const hour = i;
          return physioData.filter(
            (entry) => moment(entry.createdAt).hour() === hour,
          ).length;
        });

        // Format categories in 12-hour format with AM/PM
        categories = Array.from(
          { length: 24 },
          (_, i) => today.startOf("day").add(i, "hours").format("hh A"), // Change here
        );
        break;
      }

      case "Last 7 days": {
        // For the last 7 days, display daily data
        nurseCounts = Array.from({ length: 7 }, (_, i) => {
          const day = today
            .clone()
            .subtract(6 - i, "days")
            .format("YYYY-MM-DD");
          return nurseData.filter(
            (entry) => moment(entry.createdAt).format("YYYY-MM-DD") === day,
          ).length;
        });

        physioCounts = Array.from({ length: 7 }, (_, i) => {
          const day = today
            .clone()
            .subtract(6 - i, "days")
            .format("YYYY-MM-DD");
          return physioData.filter(
            (entry) => moment(entry.createdAt).format("YYYY-MM-DD") === day,
          ).length;
        });

        categories = Array.from({ length: 7 }, (_, i) =>
          today
            .clone()
            .subtract(6 - i, "days")
            .format("MMM D"),
        );
        break;
      }

      case "Last 30 days":
      default: {
        // For the last 30 days, display daily data
        nurseCounts = Array.from({ length: 30 }, (_, i) => {
          const day = today
            .clone()
            .subtract(29 - i, "days")
            .format("YYYY-MM-DD");
          return nurseData.filter(
            (entry) => moment(entry.createdAt).format("YYYY-MM-DD") === day,
          ).length;
        });

        physioCounts = Array.from({ length: 30 }, (_, i) => {
          const day = today
            .clone()
            .subtract(29 - i, "days")
            .format("YYYY-MM-DD");
          return physioData.filter(
            (entry) => moment(entry.createdAt).format("YYYY-MM-DD") === day,
          ).length;
        });

        categories = Array.from({ length: 30 }, (_, i) =>
          today
            .clone()
            .subtract(29 - i, "days")
            .format("MMM D"),
        );
        break;
      }

      case "Over All": {
        // For "Over All", use the full range of data
        const allDates = [...nurseData, ...physioData].map((entry) =>
          moment(entry.createdAt).startOf("day").format("YYYY-MM-DD"),
        );

        // Get unique dates
        const uniqueDates = [...new Set(allDates)];
        const startDate = moment.min(
          uniqueDates.map((date) => moment(date, "YYYY-MM-DD")),
        );
        const endDate = moment.max(
          uniqueDates.map((date) => moment(date, "YYYY-MM-DD")),
        );

        // Generate the full date range
        const dateRange = [];
        for (
          let m = startDate.clone();
          m.isBefore(endDate.clone().add(1, "day"));
          m.add(1, "day")
        ) {
          dateRange.push(m.format("YYYY-MM-DD"));
        }

        categories = dateRange;

        nurseCounts = dateRange.map((date) => {
          return nurseData.filter(
            (entry) => moment(entry.createdAt).format("YYYY-MM-DD") === date,
          ).length;
        });

        physioCounts = dateRange.map((date) => {
          return physioData.filter(
            (entry) => moment(entry.createdAt).format("YYYY-MM-DD") === date,
          ).length;
        });

        break;
      }
    }

    return {
      chart: {
        backgroundColor: "#fff",
        borderRadius: 10,
        height: 140,
        style: {
          fontFamily: "'Arial', sans-serif",
        },
        plotBorderColor: "#606063",
      },
      title: {
        text: "",
        style: {
          color: "#333",
          fontWeight: "bold",
          fontSize: "18px",
        },
      },
      xAxis: {
        categories,
        labels: {
          style: {
            color: "#474747",
            fontSize: "10px",
          },
          formatter: function () {
            if (values === "Over All") {
              return moment(this.value).format("YYYY-MM-DD"); // Format for Over All
            } else {
              return this.value; // Use the default format for other cases
            }
          },
        },
        lineColor: "#D7E4EB",
        lineWidth: 1,
        tickColor: "#333",
        gridLineColor: "#e6e6e6",
        gridLineDashStyle: "dot",
        gridLineWidth: 1.5,
      },
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          style: {
            color: "#474747",
            fontSize: "10px",
          },
        },
        gridLineColor: "#fff",
      },
      series: [
        {
          name: "Nurse",
          data: nurseCounts,
          type: "line",
          color: "#A4E472",
          lineWidth: 1.2,
          marker: {
            enabled: false,
          },
        },

        {
          name: "Physiotherapist",
          data: physioCounts,
          type: "line",
          color: "#2824F4",
          lineWidth: 1.2,
          marker: {
            enabled: false,
          },
        },
      ],
      tooltip: {
        shared: true,
        crosshairs: true,
        backgroundColor: "rgba(255, 255, 255, 0.85)",
        borderColor: "#ccc",
        style: {
          color: "#333",
          fontSize: "12px",
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    };
  };
  // console.log("cure", page);
  return (
    <div className="bg-white rounded-2xl h-[35vh] shadow-md w-[49%] ml-2">
      <div className="flex justify-between items-center">
        <p className="text-[14px] ml-5 p-1 mt-[10px] font-semibold">
          Users By Role
        </p>
      </div>
      <div className="border-b border-[#D7E4EB] mb-2 mt-[10px]"></div>
      <div className="flex mb-1  ml-5">
        <div className="flex items-center">
          <img src={DashboardImages.green} alt="Nurse" className="h-2 w-2" />
          <p className="ml-2 text-[12px]">Nurse</p>
        </div>

        <div className="flex items-center ml-4">
          <img
            src={CommonImages.playStore}
            alt="Physiotherapist"
            className="h-2 w-2"
          />
          <p className="ml-2 text-[12px]">Physiotherapist</p>
        </div>
      </div>
      <div className="p-4 max-w-[99%]">
        <HighchartsReact highcharts={Highcharts} options={getOptions()} />
      </div>
    </div>
  );
};

export default BookingBySpecialist;
